import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { MakeProvider } from '@stylehaven/components';
import { ThesaurusService } from '../../common/services/thesaurus/thesaurus.service';
import { SharedDialogHelper } from '../../dialog/helpers/dialog.helper';
import { FormThesaurusComplexBaseComponent } from '../base-complex/form-thesaurus-base-complex.component';

@Component({
    standalone: false,
    selector: 'med-form-thesaurus-base',
    templateUrl: '../base-complex/form-thesaurus-base-complex.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(FormThesaurusBaseComponent)]
})
export class FormThesaurusBaseComponent extends FormThesaurusComplexBaseComponent {
    constructor(
        changeDetectorRef: ChangeDetectorRef,
        formBuilder: UntypedFormBuilder,
        thesaurusService: ThesaurusService,
        dialogHelper: SharedDialogHelper
    ) {
        super(changeDetectorRef, formBuilder, thesaurusService, dialogHelper);
    }
}
